/* Balancer Metrics services */

import { API } from '../../Services/Api';

const request = new API();

export const getMetricsReport = (params) => {
  return request.api.get(`/reports/metrics-report/`, params);
}
